/**
 * Authentication configuration
 *
 * USE_AUTH controls whether Microsoft Entra authentication is enabled.
 * - Set VITE_USE_AUTH="false" in .env to disable auth (dev mode)
 * - If not set or any other value, auth is enabled (safe default)
 */
export const USE_AUTH = import.meta.env.VITE_USE_AUTH !== "false";
